export default __webpack_public_path__ + "locales/ko-KR/ChangeUserStatusDialog.json?hash=1cc03491ca630c50fdc77390eab5a1f7";